module.exports = __webpack_public_path__ + "static/media/clipboard.db71bd20.svg";